import React from "react";
import { useNavigate } from "react-router-dom";
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";
import normatecaStore from "../../../stores/normatecaStore";

export default function AcoordionMovil(param){
    
    const navigate= useNavigate();
    // store - zuntand
    const {setVisMenuP,visMenuMovil} =
    normatecaStore((state) =>( { 
        setVisMenuP: state.setVisMenuP,
        visMenuMovil: state.visMenuMovil,
    })); 
    
    const visualizaMenu=()=>{
      let menuI= param.menu;
      menuI.map((mp,indexp)=>{
        mp.visualiza=false;
        if (mp.nivel2){
            mp.nivel2.map((mn,index)=>{
                mn.visualiza=false;
                    if (mn.nivel3){
                        mn.nivel3.map ((m1,index1)=>{
                        m1.visualiza=false;
                        if(m1.nivel4){
                            m1.nivel4.map ((m2,index2)=>{
                                m2.visualiza=false;
                            })
                        }
                    })
            }
            })
        }
        })
      setVisMenuP("encMovil").catch(null);
    }
    const openCloseMenu=(indices)=>{
        let ind= indices.toString().split("-");
        let menuI= param.menu;
        switch(ind.length){
           case 1:
                menuI[ind[0]].visualiza= !menuI[ind[0]].visualiza;//? false:true
            break;
            case 2:
                menuI[ind[0]].nivel2[ind[1]].visualiza= !menuI[ind[0]].nivel2[ind[1]].visualiza;
            break;
            case 3:
                menuI[ind[0]].nivel2[ind[1]].nivel3[ind[2]].visualiza= !menuI[ind[0]].nivel2[ind[1]].nivel3[ind[2]].visualiza;
            break;
            case 4:
                menuI[ind[0]].nivel2[ind[1]].nivel3[ind[2]].nivel4[ind[3]].visualiza= !menuI[ind[0]].nivel2[ind[1]].nivel3[ind[2]].nivel4[ind[3]].visualiza;
            break;
        }
    }
    const cambiaContenido =(opcVis, indices)=>{
        navigate("/app/normateca/menu=" + opcVis + "_" + indices);
    }       
    return(
        /* menu */
           <Accordion  className="divAcoorMovil" as={"ul"} >
            <div id={"miAcMov" + "_" + param.indi } key={"miAcMov" + "_" + param.indi }>
               <AccordionItem key={0} >
                   <AccordionHeader  className="btnAcoorMovil lineH-n width-90Movil" onClick={visualizaMenu}>
                        <div id="ini" className="txt-align-rightMovil">
                        <span className="inegi-menu imgMenuMatMovil"></span>
                        </div>
                   </AccordionHeader>
                   <AccordionBody className={visMenuMovil? 'display-initial' : 'display-none'} >
                       <div id="div1" className="accordion-body backColor-white boxSha acoordionScroll width-30rem margin-leftMovil" key={"div1"}  >
                       {param?.menu.map((m,indexp)=>(
                             <AccordionItem key={"acip" + indexp.toString()} >
                               {m.nivel2?.length===0 ?
                                    <div id={"mip" + indexp.toString()} key={"mip" + indexp.toString()} >
                                        <button id={"btnmip" + indexp.toString()} onClick={()=>cambiaContenido(m.id, indexp)}>
                                            <div id={"mip1" + indexp.toString()} className='accordion-body linkAcoor1 ' key={"mip1" + indexp.toString()} >
                                                {m.nombre}
                                            </div>
                                        </button>
                                    </div>
                               :
                                   <div id={"mhp" + indexp.toString()} key={"mhp" + indexp.toString()} className={m.id==="0400"? "border-top-gray":""}>
                                       <AccordionHeader key={"mahp" + indexp.toString()} className='btnAcoorMovil2' onClick={()=> openCloseMenu(indexp)}>
                                           <div id={"divDF2p" + indexp.toString()} className="display-flex" key={"divDF2p" + indexp.toString()}>
                                               {m.visualiza? <div className="inegi-nav-despa padTop-0_2"></div> :<div className="inegi-nav-der padTop-0_2"></div>}
                                               <div id={"mnMov" + indexp.toString()} className="menuNiv1Movil" >
                                                    {m.nombre}
                                               </div>
                                               
                                           </div> 
                                       </AccordionHeader>
                                       <AccordionBody key={"ab1p" + indexp.toString()} className={m.visualiza?  'display-initial' : 'display-none'} >
                                        {m.nivel2?.map((mn,index2)=>(
                                           <AccordionItem key={"aciz" + index2.toString()}>
                                           {mn.nivel3?.length===0 ?
                                                    <div id={"divDF2s" + index2.toString()} className="display-flex " key={"divDF2s" + index2.toString()}>
                                                        <div id={"divvac" + index2.toString()} className="width-1-5rem"></div>
                                                        <button id={"btnmiz" + index2.toString()}  type="button" onClick={()=>cambiaContenido(mn.id, index2)} className='linkAcoor1 padNiv1 '>
                                                            <div id={"miz" + index2.toString()} className='accordion-body ' key={"miz" + index2.toString()} >
                                                                {mn.nombre}
                                                            </div>
                                                        </button>
                                                    </div>
                                            :
                                                    <div id={"mhz" + index2.toString()} key={"mhz" + index2.toString()}>
                                                    <AccordionHeader key={"mahz" + index2.toString()} className='linkAcoor1 padNiv1' onClick={()=> openCloseMenu(indexp + "-" + index2)}>
                                                        <div id={"divDF2z" + index2.toString()} className="display-flex" key={"divDF2z" + index2.toString()}>
                                                            {mn.visualiza? <div className="inegi-nav-despa padTop-0_2"></div> :<div className="inegi-nav-der padTop-0_2"></div>}
                                                            <div id={"miz2" + index2.toString()} className="width-92">
                                                                {mn.nombre}
                                                            </div>
                                                        </div> 
                                                    </AccordionHeader>
                                                    <AccordionBody key={"ab1z" + index2.toString()} className={mn.visualiza?  'display-initial' : 'display-none'} >
                                                {mn.nivel3?.map((m1,indexm1)=>(

                                                        <AccordionItem key={"aciy" + indexm1.toString()}>
                                                    
                                                            {m1['nivel4'] === undefined || m1.nivel4?.length === 0?
                                                                    <div id={"divm1y" + indexm1.toString()}  key={"divm1y" + indexm1.toString()} >
                                                                        <button id={"btnm1y"  + indexm1.toString()} type="button" onClick={()=>cambiaContenido(m1.id, index2 + "-" + indexm1)} className='accordion-body linkAcoor1 padNiv2Movil'>
                                                                            <div id={"divm2y" + indexm1.toString()} >{m1.nombre}</div>
                                                                        </button>
                                                                    </div>
                                                            :
                                                                <div id={"m1y" + indexm1.toString()} key={"m1y" + indexm1.toString()}>
                                                                    <AccordionHeader key={"acy" + indexm1.toString()} className='linkAcoor1 padNiv2Movil ' onClick={()=> openCloseMenu(indexp + "-" + index2 + "-" + indexm1)}>
                                                                    <div id={"divDF4y" + indexm1.toString()} className="display-flex" key={"divDF4y" + indexm1.toString()}>
                                                                        {m1.visualiza? <div className="inegi-nav-despa padTop-0_2"></div> :<div className="inegi-nav-der padTop-0_2"></div>}
                                                                        <div id={"divDF5y" + indexm1.toString()} className="width-90Movil">
                                                                            {m1.nombre}
                                                                        </div>
                                                                    </div>
                                                                    </AccordionHeader>
                                                                    <AccordionBody key={"abt" + indexm1.toString()} className={m1.visualiza?'display-initial' : 'display-none'} >
                                                                        {m1.nivel4?.map((m2,indexm2)=>(
                                                                            <div id={"m5t" + indexm2.toString()} key={"m5t" + indexm2.toString()}>
                                                                                <button id={"btnm5t" + indexm2.toString()} type="button" onClick={()=>cambiaContenido(m2.id, index2  + "-" + indexm1 + "-" + indexm2)} className='accordion-body linkAcoor1 padNiv3Movil' >
                                                                                    <div id={"m2t" + indexm2.toString()}  key={"m2t" + indexm2.toString()} >
                                                                                        {m2.nombre}
                                                                                    </div>
                                                                                </button>
                                                                            </div>
                                                                        ))}
                                                                    </AccordionBody>
                                                                </div>
                                                            }
                                                    </AccordionItem>
                                                ))}
                                                </AccordionBody>
                                                </div>
                                            }
                                            </AccordionItem>
                                        ))}
                                        
                                        </AccordionBody>
                                   </div>
                               }
                               </AccordionItem>
                           ))}
                           
                       </div>
                   </AccordionBody>
               </AccordionItem>
              </div>
           </Accordion>
) 
}
